import React from "react";
import { Row, Table, Badge } from "reactstrap";
import { subscriptionHeaders } from "../../../usersConfig";
import Pagination from "../../../../../../shared/components/pagination/Pagination";
import * as env from "../../../../../../env";
import client from "../../../../../../shared/api-client";
import toQueryString from "../../../../../../shared/toQueryString";
import * as CurrencyFormat from "react-currency-format";

class ProfileSubscriptions extends React.Component {
  state = {
    isOpen: false,
    subscriptions: [],
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    progress: "",
  };

  getSubscriptions = () => {
    let params = toQueryString({
      uid: this.props.id,
    });

    this.setState({
      progress: "Loading ...",
    });

    client(`user_subscriptions.php?${params}`).then(
      (response) => {
        let subscriptions = response.data.filter((o) => {
          return o.subscription_id !== "" && o.subscription_id !== null;
        });
        this.setState({
          isOpen: false,
          subscriptions: subscriptions,
          progress: subscriptions.length === 0 ? "No record found" : "",
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  printRecords = () => {
    let items = this.state.subscriptions.slice(
      this.state.startIndex,
      this.state.endIndex + 1
    );

    return (
      <React.Fragment>
        {items.map((obj) => (
          <tr key={obj.subscription_id}>
            <td>{`subsc-${obj.subscription_id}`}</td>
            <td>{obj.product}</td>
            <td>{obj.subscribed_on}</td>
            <td>{obj.valid_till}</td>
            <td className="textRight">
              <CurrencyFormat
                value={obj.cost}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
            <td>
              {obj.status === "active" ? (
                <Badge color="success" className="capitalizeCase ">
                  {obj.status}
                </Badge>
              ) : (
                <Badge color="danger" className="capitalizeCase">
                  {obj.status}
                </Badge>
              )}
            </td>
          </tr>
        ))}
      </React.Fragment>
    );
  };

  pagination = () => {
    return this.state.subscriptions.length > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.subscriptions}
          onChangePage={(pagination) => this.setState(pagination)}
          pageSize={env.RECORDS_PER_PAGE}
        />
      </div>
    ) : (
      ""
    );
  };

  componentDidMount() {
    this.getSubscriptions();
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Table
            className="table--head-accent table--bordered"
            responsive
            hover
          >
            <thead>
              <tr>
                {subscriptionHeaders.map((header) => (
                  <th key={header.name}>{header.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>{this.printRecords()}</tbody>
          </Table>
          {this.pagination()}
          {this.state.progress}
        </Row>
      </React.Fragment>
    );
  }
}

export default ProfileSubscriptions;
